import React from "react";
import InfoPageLayout from "../../components/InfoPageLayout"; // adjust path if needed
import { Link } from "react-router-dom";

export default function HelpPage() {
  const helpSections = [
    {
      title: "How to Host the EA",
      description: "Step-by-step instructions on how to host and configure your Expert Advisor for optimal performance.",
      icon: "bi bi-server",
      link: "/how-to-host"
    },
    {
      title: "Tutorial Videos",
      description: "Watch our official video guides and walkthroughs for using the platform effectively.",
      icon: "bi bi-play-circle",
      link: "/videos"
    },
    {
      title: "App & Script Downloads",
      description: "Access the latest version of our Android app, MT4/MT5 scripts, and other helpful tools.",
      icon: "bi bi-download",
      link: "/downloads"
    },
    {
      title: "Frequently Asked Questions (FAQ)",
      description: "Browse common questions and answers about using the platform, payments, and licenses.",
      icon: "bi bi-question-circle",
      link: "/faq"
    },
    {
      title: "Support & Contact Us",
      description: "Guidelines on how to get in touch with our team and what to expect.",
      icon: "bi bi-headset",
      link: "/support"
    },
    {
      title: "About Us",
      description: "Get to know more about our mission, values, and the team behind the platform.",
      icon: "bi bi-people",
      link: "/about"
    }
  ];

  return (
    <InfoPageLayout title="Help & Support" description="Find guides, videos, downloads, and answers to frequently asked questions to help you get the most out of the platform.">
      <div className="container-fluid">
        <div className="row">
          {helpSections.map((section, index) => (
            <div className="col-lg-6 col-md-12 mb-4" key={index}>
              <Link to={section.link} className="text-decoration-none text-dark">
                <div className="card h-100 shadow-sm border-0">
                  <div className="card-body d-flex flex-column align-items-center text-center">
                    <div className="text-primary mb-3">
                      <i className={`${section.icon}`} style={{ fontSize: "3.5rem" }}></i>
                    </div>
                    <h5 className="fw-semibold">{section.title}</h5>
                    <p className="text-muted">{section.description}</p>
                  </div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </InfoPageLayout>
  );
}